import { Label } from '../ui/label'
import { cn } from '../../lib/utils'
import React from 'react'
import InputError from './input-error'

/**
 * InputWrapper component props
 */
export type InputWrapperProps = {
    /**
     * Wrapper class name,
     * default is `flex flex-col gap-1.5 w-full` 
     */
    wrapperClassName?: string,

    /**
     * Label class name,
     */
    labelClassName?: string,

    /**
     * Label's htmlFor attribute value
     */
    labelFor?: string,

    /**
     * Label For Input Field
     */
    label?: string,

    /**
     * Error message
     */
    error?: string,

    /**
     * Error class name,
     * default is `text-sm text-destructive`
     */
    errorClassName?: string,
} 


/**
 * Input wrapper have label and error, 
 * created for wrapping input components, 
 * which need label and error message.
 */
function InputWrapper({
    label,
    error,
    wrapperClassName,
    labelClassName,
    children,
    errorClassName,
    labelFor,
}: InputWrapperProps & React.PropsWithChildren) {
    return (
        <div className={cn("space-y-1 w-full", wrapperClassName)}>
            {label && (<Label className={cn("text-sm pl-1", labelClassName)} htmlFor={labelFor}>{label}</Label>)}
            {children}
            {error && <InputError className={errorClassName}>{error}</InputError>}
        </div>
    )
}

export default InputWrapper